<script lang="ts">
    import type QuestionEntity from "@apps/reviews/entities/QuestionEntity";

    import QuestionItem from "./QuestionItem.svelte";

    export let questions: QuestionEntity[];
    export let namespace: string;
</script>

<ul class="gw-qa-list gw-list-reset-default-styles">
    {#each questions as question (question.id)}
        <QuestionItem {question} {namespace} />
    {/each}
</ul>

<style>
    .gw-qa-list {
        padding-top: 1em;
        display: flex;
        flex-direction: column;
        gap: 1.5em;
    }
</style>
